import {css} from '@emotion/react'

const defaultGetText = (a) => a

const cssViewDict = css({
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
})

const ViewDict = ({
    dict,
    getText = defaultGetText,
    value,
    ...props
}) => {
    const item = dict[value]
    const text = item ? getText(item) : ''

    return (
        <div
            css={cssViewDict}
            title={text}
            {...props}
        >
            {text}
        </div>
    )
}

export default ViewDict
